"use client";

import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { HomepageProfitProof } from "@/components/landing/homepage-profit-proof";
import { HOMEPAGE_PROOF_RECORDS } from "@/lib/marketing/homepage-proof-records";
import { phCapture } from "@/utils/analytics";
import styles from "./hero-profit-proof.module.css";

type ProofImage = { src: string; title: string; source?: string };

export function HeroProfitProof() {
  const [image, setImage] = useState<ProofImage | null>(null);
  const open = (record: ProofImage) => {
    setImage(record);
    phCapture("homepage_proof_opened", { surface: "home_early_proof", image: record.src });
  };

  return <div className={styles.receipts}>
    <div className={styles.visual}><HomepageProfitProof motion={!image} onOpen={open} hiddenOnPhones /></div>
    <div className={styles.originals} role="group" aria-label="View original receipts">
      {HOMEPAGE_PROOF_RECORDS.map((record) => <button type="button" key={record.id} onClick={() => open(record)} aria-label={`${record.label} — view ${record.name}’s original receipt`}>
        {record.label} <ArrowUpRight size={12} aria-hidden="true" />
      </button>)}
    </div>
    <Dialog open={!!image} onOpenChange={(open) => { if (!open) setImage(null); }}>
      <DialogContent className="w-[calc(100%-24px)] max-w-[1000px]" contentClassName="max-h-[90dvh] overflow-auto p-4 sm:p-6">
        <DialogTitle>Original receipt</DialogTitle>
        <DialogDescription>{image?.title}</DialogDescription>
        {image && <><img src={image.src} alt={image.title} className="mx-auto max-h-[65dvh] w-auto max-w-full object-contain" />{image.source && <a href={image.source} target="_blank" rel="noopener noreferrer" className={styles.textLink}>View the original post <ArrowUpRight size={16} /></a>}</>}
      </DialogContent>
    </Dialog>
  </div>;
}
